import dayjs from 'dayjs';

export function getBool(value?: number | string) {
	if (!value) {
		return false;
	};
	if (value === 1 || value === '1') {
		return true;
	}
	return false;
}
/** 秒转为毫秒 */
export function second2Ms(second: number) {
	return second * 1000;
}
/**
 * 是否是今年
 */
export function isThisYear(ts: number) {
	return dayjs(second2Ms(ts)).isSame(dayjs(), 'year');
}

/**
 * 格式化timeStamp(秒)
 * eg: 2022-03-12
 */
export function formatTimeStamp(
	ts: number | undefined,
	template: string = "YYYY-MM-DD"
) {
	return dayjs(second2Ms(ts || 0)).format(template);
}


// 保存之前的body的overflow样式
let previousBodyOverflowStyle: null | string = null;

// 添加防止滚动穿透的样式
export function preventScrolling() {
	// 保存之前的body的overflow样式，如果已保存，则不再重复保存
	if (previousBodyOverflowStyle === null) {
		previousBodyOverflowStyle = window.getComputedStyle(document.body).overflow;
	}

	// 添加样式以防止滚动穿透
	document.body.style.overflow = 'hidden';
	// 移除防止滚动穿透的样式
	function allowScrolling() {
		// 恢复之前保存的body的overflow样式
		if (previousBodyOverflowStyle !== null) {
			document.body.style.overflow = previousBodyOverflowStyle;
			previousBodyOverflowStyle = null;
		}
	}
	return allowScrolling
}


